import https from 'https'
import { cacheAdapterEnhancer } from 'axios-extensions'
import LRU from 'lru-cache'

const TEN_MINUTES = 1000 * 60 * 10

// timing store (works with cached responses)
// const timingStore = new Map()

// function makeKey(config) {
//   const method = (config.method || 'get').toLowerCase()
//   const base = config.baseURL || ''
//   const url = config.url || ''
//   const params = config.params ? JSON.stringify(config.params) : ''
//   return `${method}:${base}${url}:${params}`
// }

export default function({ $axios, ssrContext, redirect }) {
  $axios.defaults.timeout = parseInt(process.env.AWS_API_TIMEOUT || '30000', 10)

  const defaultCache = process.server ? ssrContext.$axCache : new LRU({ maxAge: TEN_MINUTES })

  const defaults = $axios.defaults

  defaults.adapter = cacheAdapterEnhancer(defaults.adapter, {
    enabledByDefault: false,
    cacheFlag: 'useCache',
    defaultCache
  })

  function fmtMethod(m) {
    return String(m || 'GET').toUpperCase()
  }

  // REQUEST
  $axios.onRequest(config => {
    // const key = makeKey(config)

    // // store start time
    // timingStore.set(key, process.hrtime.bigint())
    // config.__timingKey = key

    const fullUrl = `${config.baseURL || ''}${config.url || ''}`
    console.log(`[AXIOS →] ${fmtMethod(config.method)} ${fullUrl}`)
  })

  // RESPONSE
  $axios.onResponse(response => {
    // const key = response.config.__timingKey || makeKey(response.config)
    // const start = timingStore.get(key)
    // const end = process.hrtime.bigint()

    // if (start) timingStore.delete(key)

    // const ms = start ? Number(end - start) / 1e6 : null

    // console.log(`[AXIOS ←] ${response.status} ${response.config.url} ${ms !== null ? ms.toFixed(1) : '?'}ms`)
    console.log(`[AXIOS ←] ${response.status} ${response.config.url}`)
    return response
  })

  // ERROR
  $axios.onError(error => {
    const status = error.response?.status
    const fullUrl = `${error.config?.baseURL || ''}${error.config?.url || ''}`

    // const key = error.config?.__timingKey || makeKey(error.config || {})
    // const start = timingStore.get(key)
    // const end = process.hrtime.bigint()

    // if (start) timingStore.delete(key)

    // const ms = start ? Number(end - start) / 1e6 : null

    // console.log(`[AXIOS ✖] ${status || 'NO_STATUS'} ${fullUrl} ${ms !== null ? ms.toFixed(1) : '?'}ms`)
    console.log(`[AXIOS ✖] ${status || 'NO_STATUS'} ${fullUrl}`)

    if (error.response?.data) {
      const data = error.response.data
      const snippet = typeof data === 'string' ? data.slice(0, 800) : JSON.stringify(data).slice(0, 800)
      console.log(`[AXIOS ✖] bodySnippet=${snippet}`)
    }

    if (error.response?.headers) {
      console.log(`[AXIOS ✖] respHeadersKeys=${Object.keys(error.response.headers).join(',')}`)
    }

    if (status === 400) {
      redirect('/404')
    }

    return Promise.reject(error)
  })

  // TLS bypass (non-production only)
  if (process.server && process.env.NODE_ENV !== 'production') {
    const agent = new https.Agent({ rejectUnauthorized: false })
    $axios.defaults.httpsAgent = agent
    console.warn('[AXIOS] TLS verification disabled because NODE_ENV != production')
  }
}
